import {
    Charity,
    Distribution,
    DistributionType,
    EstateFlowchartState,
    Outright,
    Trust
} from "../model/EstateFlowchartTypes";
import {isTrust} from "../utils/DefUtils";

export const TEXTAREA_FIELD_REGEX = "^[a-zA-Z0-9 \.\\\-\/'\n,*%$&]*$";
export const VALID_CHARACTERS = "abcABC123 .-/',*%$&";
export const SPECIAL_CHARACTERS = "!@#^():;"
export const EVENT_NAME_MAX_LENGTH = 50;
/**
 * Checks if the given string is valid.
 * A string is considered valid if it is not undefined and contains
 * at least one non-whitespace character.
 *
 * @param value - The string to be validated.
 * @returns `true` if the string is valid, otherwise `false`.
 */
export const isValid = (value: string | undefined | null) => {
    return !!(value && value.replace(/\s/g, '').length > 0);
}

export const sanitize = (value: string) => {
    return value?.replace(/\?/g, '');
}

export const filterTrusts = (distributions: Distribution[]) => {
    return distributions.filter((distribution) =>
        isTrust(distribution.distributionType)
    ) as Trust[];
}

export const filterCharities = (distributions: Distribution[]) => {
    return distributions.filter((distribution) =>
        DistributionType.CHARITY === distribution.distributionType
    ) as Charity[];
}

export const filterOutrights = (distributions: Distribution[]) => {
    return distributions.filter((distribution) =>
        DistributionType.OUTRIGHT === distribution.distributionType
    ) as Outright[];
}

export const isFlowchartNameDuplicate = (estateFlowcharts: EstateFlowchartState[] ,name: string) => {
    let flowchartNames = new Set<string>();
    estateFlowcharts.forEach(fc => {
        if (fc.flowchartName) {
            flowchartNames.add(fc.flowchartName.toLowerCase());
        }
    });
    return flowchartNames.has(name.toLowerCase());
}